import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TrxServicesAchPage } from './trxservices-ach.page';

const routes: Routes = [
  {
    path: '',
    component: TrxServicesAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class TrxServicesAchPageRoutingModule {}
